<script setup>
import { computed } from 'vue';
import { Handle, Position } from '@vue-flow/core';
import { useStoreGetters } from 'dashboard/composables/store';
import { NODE_TYPES } from '../../constants';
import FlowNodeCard from './FlowNodeCard.vue';

const props = defineProps({
  data: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});
const meta = NODE_TYPES.sub_flow;
const getters = useStoreGetters();
const flowName = computed(() => {
  if (!props.data.flow_id) return '';
  return getters['botFlows/getBotFlow'].value(props.data.flow_id)?.name || '';
});
</script>

<template>
  <FlowNodeCard :icon="meta.icon" :color="meta.color" :title="meta.label" :selected="selected">
    <Handle type="target" :position="Position.Left" />
    <p v-if="flowName">Continua no fluxo "{{ flowName }}" (não volta pra cá).</p>
    <p v-else class="text-n-slate-9">Selecione o fluxo a executar.</p>
  </FlowNodeCard>
</template>
